import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Card, Checkbox, Form, Input, InputNumber } from 'antd';
import LoadingSpinner from '../../components/loading-spinner/loading-spinner';
import api from '../../api';
import _ from 'lodash';
import FaIcon from '../../components/global/fa-icon/fa-icon';



class TheaterEditView extends Component {

  constructor(props) {
    super(props);

    let id = _.get(this, 'props.match.params.id', null);

    this.state = {
      loaded: false,
      saving: false,
      id: id,
      data: null,
    };

    this.onNicknameChanged = this.onNicknameChanged.bind(this);
    this.onSortIndexChanged = this.onSortIndexChanged.bind(this);
    this.onNameChanged = this.onNameChanged.bind(this);
    this.onAddressChanged = this.onAddressChanged.bind(this);
    this.onPhoneChanged = this.onPhoneChanged.bind(this);
    this.onNumScreensChanged = this.onNumScreensChanged.bind(this);
    this.onClosedForSeasonChanged = this.onClosedForSeasonChanged.bind(this);
    this.onSupportsDigitalChanged = this.onSupportsDigitalChanged.bind(this);
    this.onSupportsDigital4KChanged = this.onSupportsDigital4KChanged.bind(this);
    this.onSupports3DChanged = this.onSupports3DChanged.bind(this);
    this.onCommentsChanged = this.onCommentsChanged.bind(this);
    this.onManagerNotesChanged = this.onManagerNotesChanged.bind(this);

    this.onSaveClicked = this.onSaveClicked.bind(this);
    this.onBackClicked = this.onBackClicked.bind(this);
    this.onCancelClicked = this.onCancelClicked.bind(this);

    this.invalidateData(false);
  }

  invalidateData(forceUpdate = false) {
    let id = this.state.id;

    if (forceUpdate || !this.state.loaded) {
      this.prevQuery = null;
    }
    if (this.prevQuery && _.isEqual(this.prevQuery, id)) {
      return false;
    }
    this.prevQuery = id;

    api.theaters.get(id).then(res => {
      let item = _.get(res, 'data') || {};

      this.setState({ loaded: true, data: item });
      return true;
    });
  }

  isAddMode() {
    return !this.state.id;
  }

  _getTargetStringValue(e, trim = false) {
    let value = _.get(e, 'target.value');
    if (trim) {
      value = _.trim(value);
    }
    if (!value || _.isEmpty(value)) { value = null; }
    return value;
  }

  onNicknameChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.nickname = value;
    this.setState({ data });
  }

  onSortIndexChanged(value) {
    let data = this.state.data;
    data.sortIndexIntValue = value;
    this.setState({ data });
  }

  onNameChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.name = value;
    this.setState({ data });
  }

  onAddressChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.address = value;
    this.setState({ data });
  }

  onPhoneChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.phone = value;
    this.setState({ data });
  }

  onNumScreensChanged(value) {
    let data = this.state.data;
    data.num_screens = value;
    this.setState({ data });
  }

  onClosedForSeasonChanged(e) {
    let value = !!_.get(e, 'target.checked', false);
    let data = this.state.data;
    data.closedForSeasonBooleanValue = value;
    this.setState({ data });
  }

  onSupportsDigitalChanged(e) {
    let value = !!_.get(e, 'target.checked', false);
    let data = this.state.data;
    data.supportsDigitalBooleanValue = value;
    this.setState({ data });
  }

  onSupportsDigital4KChanged(e) {
    let value = !!_.get(e, 'target.checked', false);
    let data = this.state.data;
    data.supportsDigital4KBooleanValue = value;
    this.setState({ data });
  }

  onSupports3DChanged(e) {
    let value = !!_.get(e, 'target.checked', false);
    let data = this.state.data;
    data.supports3DBooleanValue = value;
    this.setState({ data });
  }

  onCommentsChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.comments = value;
    this.setState({ data });
  }

  onManagerNotesChanged(e) {
    let value = this._getTargetStringValue(e);
    let data = this.state.data;
    data.manager_notes = value;
    this.setState({ data });
  }

  onSaveClicked(e) {
    let modelData = this.state.data;
    this.setState({ loaded: false, saving: true }, () => {
      api.theaters.save(modelData.id, modelData).then(res => {
        let newId = _.get(res, 'data.id') || null;
        if (this.isAddMode() && newId) {
          this.props.history.push('/theaters/edit/' + newId);
        }
        this.setState({ id: newId, loaded: false, saving: false }, () => {
          this.invalidateData(true);
        });
      });
    });
  }

  onBackClicked(e) {
    this.props.history.push('/theaters');
  }

  onCancelClicked(e) {
    this.onBackClicked();
  }

  render() {

    let id = _.get(this, 'state.data.id') || _.get(this, 'state.id') || null;
    let title = id? ('Edit Theater ' + id): 'Add Theater';

    let titleActions = (
      <div className="title-actions">
        <Button type="default" size="large" icon={<FaIcon icon="fa-arrow-alt-left" />} onClick={this.onBackClicked}>Back</Button>
        <div className="title-text">{title}</div>
      </div>
    );

    let actions = (
      <div className="card-actions action-buttons">
        <Button type="default" size="large" icon={<FaIcon icon="fa-times"/>} onClick={this.onCancelClicked}>Cancel</Button>
        <Button type="primary" size="large" icon={<FaIcon icon="fa-check"/>} onClick={this.onSaveClicked}>Save</Button>
      </div>
    );

    return (
      <div className="theater-edit-view mx-auto" >
        <Card title={titleActions} extra={actions}>
          <div className="page-content">
            { (!this.state.loaded)? <LoadingSpinner />: null }

            { (this.state.loaded)? this.renderEditArea(): null }

            { (false && this.state.loaded)? this.renderJsonData(): null }
          </div>
        </Card>
      </div>
    );
  }

  renderEditArea() {
    let data = this.state.data;

    return (
      <Form className="edit-theater-content d-flex flex-row" layout="vertical">
        <div className="details-area container-fluid">

          <div className="row">
            <div className="col-sm-8 col-12">
              <Form.Item label="Name" colon={false}>
                <Input className="fillx" value={data.name} onChange={this.onNameChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-2 col-12">
              <Form.Item label="Nickname" colon={false}>
                <Input className="fillx" value={data.nickname} onChange={this.onNicknameChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-2 col-12">
              <Form.Item label="Sort Order" colon={false}>
                <InputNumber className="fillx" min={0} max={999} value={data.sortIndexIntValue} onChange={this.onSortIndexChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-8 col-12">
              <Form.Item label="Address" colon={false}>
                <Input className="fillx" value={data.address} onChange={this.onAddressChanged} />
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Phone Number" colon={false}>
                <Input className="fillx" value={data.phone} onChange={this.onPhoneChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 col-12">
              <Form.Item label="Supports Digital" colon={false}>
                <Checkbox checked={data.supportsDigitalBooleanValue} onChange={this.onSupportsDigitalChanged}>Supports Digital Movies?</Checkbox>
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Supports Digital 4K" colon={false}>
                <Checkbox checked={data.supportsDigital4KBooleanValue} onChange={this.onSupportsDigital4KChanged}>Supports Digital 4K Movies?</Checkbox>
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Supports 3D" colon={false}>
                <Checkbox checked={data.supports3DBooleanValue} onChange={this.onSupports3DChanged}>Supports 3D Movies?</Checkbox>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 col-12">
              <Form.Item label="Number of Screens" colon={false}>
                <InputNumber disabled className="fillx" min={0} max={99} value={data.num_screens} onChange={this.onNumScreensChanged}/>
              </Form.Item>
            </div>
            <div className="col-sm-4 col-12">
            </div>
            <div className="col-sm-4 col-12">
              <Form.Item label="Closed for the Season" colon={false}>
                <Checkbox checked={data.closedForSeasonBooleanValue} onChange={this.onClosedForSeasonChanged}>Is Theater Closed for the Season?</Checkbox>
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Comments" colon={false}>
                <Input.TextArea rows={3} value={data.comments} onChange={this.onCommentsChanged} />
              </Form.Item>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12 col-12">
              <Form.Item label="Optional Manager Notes" colon={false}>
                <Input.TextArea rows={3} value={data.manager_notes} onChange={this.onManagerNotesChanged} />
              </Form.Item>
            </div>
          </div>

        </div>
      </Form>
    );
  }

  renderJsonData() {
    return (
      <pre>{ JSON.stringify(this.state.data, null, 2) }</pre>
    );
  }

}



function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}


const mapDispatchToProps = {
  // setAuthState,
  // getAuthSessionStateToken,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TheaterEditView));

